export interface IOption {
  id: string
  label: string
  imageUrl?: string | null
}

export interface IUser {
  id: string
  email: string
  role: string
  created: string
  deleteRequestedAt?: string // ISO date string if deletion requested
}

export interface IUserProfile {
  id: string
  avatar: string
  fullName: string
  username: string
  gender: string
  birthday: string
  user: string // relationship to user
}

// Metadata types (shared between Firebase and PocketBase)
export interface IBrand {
  id: string
  name: string
  image?: string
}

export interface INote {
  id: string
  name: string
  image?: string
}

export interface IPerfumer {
  id: string
  name: string
}

export interface ICountry {
  id: string
  name: string
}

export interface IPrice {
  id: string
  name: string
}

export type ApprovalStatus = 'pending' | 'approved' | 'denied'

export enum AuthFetchStatus {
  Success = 'success',
  Error = 'error',
  Deleted = 'deleted',
  Unauthorized = 'unauthorized',
}